import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { merge, Observable, of, timer } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { IPageDataViewModel } from 'src/app/share/pages/pages';
import { CommonService } from 'src/app/share/services/common.service';
import { IDeploymentContext, ShellService } from '../shell.service';

import { EclsPowerBiReportComponent, IPowerBiReportViewModel } from 'src/app/share/components/ecls-power-bi-report/ecls-power-bi-report.component';
import { environment } from 'src/environments/environment';
import { AuthService } from 'src/app/share/services/auth.service';
import { IPayrollCompareCardViewModel } from 'src/app/chauffeurs/payroll/payroll-compare-card/payroll-compare-card.component';

@Component({
  selector: 'app-home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.scss']
})
export class HomePageComponent implements OnInit {

  constructor(private svc: CommonService, private shellService: ShellService, private router: Router, private authService: AuthService) { }

  vm$: Observable<IViewModel>;

  customerAction(vm: IViewModel, code: string) {
    if (code == 'manifest') {
      this.router.navigate(['reservations', 'manifest']);
    }
  }

  /**
   *
   * @returns
   */
  getData(): Observable<IPageDataViewModel> {
    var ret$ = environment.deploymentType != "chauffeur" ? this.svc.getData('PageCommand', 'home', 'page-load', undefined)
      : this.svc.getData('PageCommand', 'home', 'page-load', { driverCode: this.authService.currentState()?.user?.driverCode }, '/api/ChauffeurPortal');
    return ret$;
  }

  /**
   *
   */
  ngOnInit() {
    this.vm$ = this.getData().pipe(
      switchMap((v: IPageDataViewModel) => {

        const vm: IViewModel = {
          ...v,
          refreshEnabled: undefined,
          deploymentContext: { ...this.shellService.deploymentContext() }
        };
        console.log('home', vm);
        if (vm.workingText || vm.errorText)
          return of (vm);

        vm.refreshEnabled = false;
        vm.refreshCompletedDateTime = new Date(Date.now());
        if (vm.data.external?.reportConfig)
          vm.powerBiReportVm = EclsPowerBiReportComponent.powerBiReportVm(vm.data.external.reportConfig);

        return merge(
          of(vm),
          timer(5000, 5000).pipe(
            switchMap((n, ndx) => {
              if (!vm.refreshEnabled)
               return of(vm);

              return this.getData().pipe(
                map((latest: IPageDataViewModel) => {

                  vm.refreshWorkingText = latest.workingText ? 'Refreshing...' : undefined;
                  vm.refreshErrorText = latest.errorText;
                  vm.refreshCompletedDateTime = undefined;

                  if (!vm.refreshWorkingText && !vm.refreshErrorText) {
                    vm.data = latest.data;
                    vm.refreshCompletedDateTime = new Date(Date.now());
                  }
                  
                  return vm;
                })
              )
            })
          )
        )
      })
    );
  }

}

interface IViewModel extends IPageDataViewModel {
  data?: {
    panels?: IPanel[],
    customer?: ICustomer,
    external?: IExternal,
    chauffeur?: IChauffeur;
  }

  powerBiReportVm?: IPowerBiReportViewModel;

  deploymentContext: IDeploymentContext;

  refreshEnabled: boolean;
  refreshWorkingText?: string;
  refreshErrorText?: string;
  refreshCompletedDateTime?: Date;
}

interface IPanel {

}

interface ICustomer {

}

interface IChauffeur {
  driverInfo: {
    id: number;
    code: string;
    name: string;
    cell: string;
    typeCode: string;
    statusCode: string;
    showTimeClockTab: boolean;
    showPayrollTab: boolean;
  };

  payrollInfo: {
    driverCode: string;
    periodDate: string;

    payrollCompareVm: IPayrollCompareCardViewModel;
  }

  reviewInfo: {
    count: number;
    average: number;
    lastDate: string;
    missing: number;
  }
}

interface IExternal {
  title: string;
  reportConfig: any;
}
